var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DrInfoTop'),_vm._v(" "),_c('DrInfoSearch',{attrs:{"queryParams":_vm.queryParams,"fullDate":_vm.fullDate}}),_vm._v(" "),_c('DrInfoList',{attrs:{"queryParams":_vm.queryParams,"fieldItems":_vm.fieldItems,"fullDate":_vm.fullDate}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5360032c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/content/ContentStatisticsInfo.vue
// module id = null
// module chunks = 